import * as React from 'react';
import type { SVGProps } from 'react';

const SvgWhiteCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M10.298 4.602 6.424 8.427 5.37 7.221a.646.646 0 0 0-.973.85l1.508 1.724a.646.646 0 0 0 .463.22h.023c.17 0 .333-.066.454-.186l4.362-4.307a.647.647 0 0 0-.908-.92ZM7.75 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWhiteCheckIcon;
